module.exports = __webpack_public_path__ + "img/spotify-roulette.c9b6de73.jpg";